/* eslint-disable @typescript-eslint/no-explicit-any*/ // TODO
import { ref, inject, computed } from "vue";
import { usePageStore } from "../pageState/store";
import ChildrenList from "./ChildrenList.3.vue";
import ErrorList from "./ErrorList.3.vue";
import HelpIcon from "@/lib/HelpIcon.3.vue";
import AdminSettingsDifferences from "./AdminSettingsDifferences.3.vue";
import Comments from "./Comments.3.vue";
import { BaseElementDef } from "../elements/BaseElementDef";
import { FormDefinitionItem } from "../elements/__DefinitionDataInterface";
import { IElementSettings } from "@cs-ts/i-element-settings";
import type mitt from "mitt";
import { useObservable } from "@vueuse/rxjs";
import { isNullOrWhitespace } from "@/lib/whitespaceMethods";
import { FormItem } from "@/cs-ts-bridge/ts/form-item";
//import Comments from "./Comments.3.vue";
export const props = ["data", "viewOnly"];
export const components = {
    ChildrenList,
    AdminSettingsDifferences,
    ErrorList,
    HelpIcon,
    Comments,
};

export interface Props<T extends BaseElementDef<T2, FormDefinitionItem<T2>, FormItem>, T2 extends IElementSettings> {
    data: T; // TODO
    viewOnly: boolean;
}
export function setup<T extends BaseElementDef<T2, FormDefinitionItem<T2>, FormItem>, T2 extends IElementSettings>(props: Props<T, T2>) {
    const elementFilter = inject("elementFilter", (el: any) => true);
    const pageStore = usePageStore();
    const oldValue = ref<any>(null);

    const customErrorIds = useObservable(props.data.customErrorIds$());

    const showAdminEditControls = computed(() => {
        return pageStore.canAdminEditData;
    });
    const isAdminEditing = computed({
        get() {
            return pageStore.isAdminEditingById(vmId.value);
        },
        set(newValue) {
            pageStore.setAdminEditing({ vmId: vmId.value, enabled: newValue });
        },
    });
    const isViewOnly = computed(() => {
        return props.viewOnly && !isAdminEditing.value;
    });
    const definition = computed(() => {
        return props.data.definition;
    });
    const settings = computed<T2>(() => {
        return props.data.definition.settings as T2;
    });
    const colClass = computed(() => {
        return "col-md-" + (settings.value.columns || 12);
    });
    const vmId = computed(() => {
        return props.data.vmId || props.data.id!;
    });
    const children = computed(() => {
        return pageStore.getChildrenByVmId(vmId.value)!.filter(elementFilter);
    });
    const value = computed({
        get() {
            const r = pageStore.getValueByVmId(vmId.value);
            //console.log("Get value: "+JSON.stringify({ id: this.vmId, value: r }));
            return r;
        },
        set(newValue) {
            //console.log("Set value: "+JSON.stringify({ id: vmId.value, value: newValue }));
            pageStore.setValueByVmId({ id: vmId.value, value: newValue! });
        },
    });
    const errorId = computed(() => {
        return vmId.value + "_Errors";
    });
    const errorIds = computed(() => {
        return `${errorId.value} ${customErrorIds.value}`.trimEnd();
    });
    const hasCustomErrors = computed(() => {
        return !isNullOrWhitespace(customErrorIds.value);
    });
    const customErrorClass = computed(() => {
        return hasCustomErrors.value ? "has-custom-errors" : null;
    });

    //async saveAdminEdit() {
    //    await this.$store.dispatch('page/invokeForm', { type: 'AdminEdit', target: /* TODO not unique - ForEach */ this.data.id, data: [this.value] });
    //    this.isAdminEditing = false;
    //},
    const toggleAdminEdit = () => {
        if (isAdminEditing.value) {
            cancelAdminEdit();
        } else {
            startAdminEdit();
        }
    };
    const startAdminEdit = () => {
        oldValue.value = value.value;
        isAdminEditing.value = true;
    };
    const cancelAdminEdit = () => {
        value.value = oldValue.value;
        isAdminEditing.value = false;
    };
    const childStyle = (child: any) => {
        const hasBaseChanges = child.baseChanges != null && child.baseChanges.length > 0;
        const hasNoBaseLink = false; //TODO (this.$parent?.data || this.$parent?.$parent?.data)?.baseLink != null && child.baseLink == null;
        return hasNoBaseLink || hasBaseChanges
            ? {
                  "min-height": "5px",
                  "border-style": "dashed",
                  "border-width": "2px",
                  "border-color": hasBaseChanges ? "blue" : hasNoBaseLink ? "red" : "green",
              }
            : {};
    };

    const a = {
        elementFilter,
        showAdminEditControls,
        isAdminEditing,
        isViewOnly,
        definition,
        settings,
        colClass,
        vmId,
        children,
        value,
        errorId,
        hasCustomErrors,
        customErrorClass,
        errorIds,

        //oldValue,

        toggleAdminEdit,
        startAdminEdit,
        cancelAdminEdit,
        childStyle,
    };
    const b = {
        ...a,
        focus: null as (() => void) | null | undefined,
        pageStore,
        expose: a,
    };

    const eventBus = inject("pageEventBus") as ReturnType<typeof mitt>;
    //@ts-ignore
    eventBus.on("focus", (eventArgs: string) => {
        if (b.vmId.value == eventArgs) {
            if (b.focus != null) {
                b.focus();
            } else {
                setTimeout(() => {
                    (document.querySelector("#PageNavigation .list-group-item.active") as HTMLElement)?.focus();
                }, 0);
            }
        }
    });

    return b;
}
